import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { downloadCSV, trans } from "utils/helpers";
import { getAllReportsDatabases, reinitializeReportsDatabases, setAsDefault } from "./api";
import { MessageType } from "types/enum";

export const ReportsDatabasesForm = () => {
    const [resetForm, setResetForm] = useState(false);
    const [response , setResponse ] = useState<Response | any>(null);
    const [selectedObj , setSelectedObj ] = useState< any>();
    const [loading , setLoading] = useState(false)
    const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
    const [forceUpdate, setForceUpdate] = useState(false);

    const clickToolbarCallback = (clickedButtonName: string) => {

        switch (clickedButtonName.toLowerCase()) {
          case "print":alert("print ");break;
          case "refresh":setForceUpdate(!forceUpdate); break;
          case "create":handleCreateDatabas();break;
          case "excel" : downloadCSV(response ,1 ,trans("ReportsDatabasesForm"));break;

        }
      };

  const handleCreateDatabas = async() => {
        try {
            setLoading(false)
            const res = await reinitializeReportsDatabases();
            getReportsDatabasesorganizationIdAsync()
        } catch (error) {
        }
        setLoading(true)
   }
    async function getReportsDatabasesorganizationIdAsync() {
      setLoading(false)
      try{
        const res = await getAllReportsDatabases();
        setResponse(res.Data)
        setCatchMessage({type:"info",msg:"NoDataForPreview"})
      } catch (error:any) {
          setCatchMessage({type:"error" , msg:error?.response?.data?.Message})
          }
          setLoading(true)
    }

    const setAsDefaultAsync=async()=>{
      try{
          await setAsDefault(selectedObj.Id)
          setForceUpdate(!forceUpdate)
      }catch(error){}
    }

    const selectedIdCallback = (obj, index) => {
      if(sessionStorage.getItem("changingforms")+""=="true"){
          // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{setSelectedObj(obj);sessionStorage.setItem("changingforms" , "false"); });
          Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{setSelectedObj(obj);sessionStorage.setItem("changingforms" , "false"); });

      }else{
        setSelectedObj(obj)         
      };
    }
     useEffect(() => {
          if (resetForm) {
            setResetForm(false);
        }
      }, [resetForm]);

    useEffect(() => {
      getReportsDatabasesorganizationIdAsync()
    }, [forceUpdate]);




    return (
        <div className="person-contact-form card p-3">
            <div className="">
            <Toolbar  view={false} emptyList={response == null || response?.length == 0} id={selectedObj?.Id} create={true} remove={false} edit={false} search={false}   handleClickToolbar={clickToolbarCallback} />
                    <div className="">
                    {loading ?
                        <>
                       {   response && response?.length>0 ?
                          <div className="mt-4">
                         <DataGrid
                         customFuction={
                        [  [(e) => {  setAsDefaultAsync()}, "map-pin", "setasdefault"]]

                         }
                          parentName={"ReportsDatabasesForm"}
                          startIndex={1}
                          theadData={Object.keys(response[0])}
                          tbodyData={response}
                          minCellWidth={80}
                          scrollHeight={"300px"}
                          selectedRowObjectCallback={selectedIdCallback}             
                          /> </div> 
                        : <Message message={catchMessage.msg} type={catchMessage.type} />    }                      
                        </>
    
                        : <Loading />
                        }
                    </div>
                </div>
        </div>
    );
}